module.exports = __webpack_public_path__ + "836aeb13ca381574f31059ebbff2bf32.svg";